import { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { FaHome } from "react-icons/fa"; // İKON EKLENDİ
import styles from "./styles.module.css";

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const Login = () => {
    const [data, setData] = useState({ email: "", password: "" });
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleChange = ({ currentTarget: input }) => {
        setData({ ...data, [input.name]: input.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const adminEmail = "av.aliardagul@gmail.com"; // Sadece bu e-posta ile girişe izin verilecek
        if (data.email !== adminEmail) {
            setError("Bu sayfaya sadece admin erişebilir.");
            return;
        }
    
        try {
            const response = await axios.post(`${apiUrl}/api/users/login`, {
                email: data.email,
                password: data.password,
            });

            const { id, username, email, avatar } = response.data;

            localStorage.setItem("userId", id);
            localStorage.setItem("username", username);
            localStorage.setItem("email", email);
            localStorage.setItem("avatar", avatar);

            navigate("/admin");
        } catch (error) {
            setError(error.response?.data?.error || "Giriş başarısız!");
        }
    };

    return (
        <div className={styles.login_container}>
            {/* 🏠 Siteye Dön Butonu */}
            <Link to="/" className={styles.back_home_link}>
                <button className={styles.back_home_btn}>
                    <FaHome style={{ marginRight: "8px" }} />
                    Siteye Dön
                </button>
            </Link>

            <div className={styles.login_form_container}>
                <div className={styles.left}>
                    <form className={styles.form_container} onSubmit={handleSubmit}>
                        <h1>Hesabınıza Giriş Yapın</h1>
                        <input
                            type="email"
                            placeholder="Email"
                            name="email"
                            onChange={handleChange}
                            value={data.email}
                            required
                            className={styles.input}
                        />
                        <input
                            type="password"
                            placeholder="Şifre"
                            name="password"
                            onChange={handleChange}
                            value={data.password}
                            required
                            className={styles.input}
                        />
                        {error && <div className={styles.error_msg}>{error}</div>}
                        <button type="submit" className={styles.green_btn}>
                            Giriş Yap
                        </button>
                    </form>
                    <Link to="/forgot-password">
                        <button className={styles.white_btn}>Şifreni mi unuttun?</button>
                    </Link>
                </div>
                <div className={styles.right}>
                   
                </div>
            </div>
        </div>
    );
};

export default Login;
